/* eslint-disable */
import React from 'react'
import {accounting} from 'accounting'
class ProductFactorComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let {aggregation, factors} = this.props

    return (
      <table className="baseTable">
        <tbody>
          <tr className="firstRow">
            <td>ردیف</td>
            <td>شناسه فاکتور</td>
            <td>شماره فاکتور</td>
            <td>تعداد</td>
            <td>مقدار</td>
            <td>واحد شمارش</td>
            <td className="priceCell">قیمت کل</td>
            <td className="priceCell">تخفیف</td>
            <td className="priceCell">قابل پرداخت</td>
          </tr>
          {factors.map((product, index) => (
            <tr key={index}>
              <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
              <td>{product.invoiceId}</td>
              <td>{product.invoiceNum}</td>
              <td>{product.productQuantityCount == '0' ? '-' : product.productQuantityCount}</td>
              <td>{product.productQuantityValue}</td>
              <td>{product.productUnitTitle}</td>
              <td className="priceCell">{accounting.formatMoney(product.totalAmount, '', ',')}</td>
              <td className="priceCell">
                {accounting.formatMoney(Number(product.discountAmount) + Number(product.extraDiscountAmount), '', ',')}
              </td>
              <td className="priceCell">{accounting.formatMoney(product.payableAmount, '', ',')}</td>
            </tr>
          ))}
          <tr>
            <td colSpan={3}>مجموع</td>
            <td colSpan={1}>{aggregation.productQuantityCount}</td>
            <td colSpan={1}>{aggregation.productQuantityValue}</td>
            <td />
            <td className="priceCell" colSpan={1}>
              {accounting.formatMoney(aggregation.totalAmount, '', ',')}
            </td>
            <td className="priceCell" colSpan={1}>
              {accounting.formatMoney(aggregation.discountAmount + aggregation.extraDiscountAmount, '', '')}
            </td>
            <td className="priceCell" colSpan={1}>
              {accounting.formatMoney(aggregation.payableAmount, '', ',')}
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}
export default ProductFactorComponent
